import React from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import EntryWrapper from '../../../components/EntryWrapper';
import HollywoodPage from '../../../components/hollywood/HollywoodPage';

const HollywoodPageEntry: React.FC = () => {
  useImpressionManager();

  return (
    <EntryWrapper isDarkTheme>
      <HollywoodPage />
    </EntryWrapper>
  );
};

export default HollywoodPageEntry;
